import { reducerWithInitialState } from "typescript-fsa-reducers";
import { combineReducers } from "redux";

import { EntitiesMap } from "../entities";
import { mergeEntities } from "../../lib/entities";
import { loadCompanyValueFeatures, bootstrapValuesIndex, loadCompaniesByCompanyValues } from "../actions";
import searchReducer, { CompanyValueSearchState } from "./search";

export interface CompanyValuesMainState {
  list: EntityId[];
  isLoading: boolean;
  isLoaded: boolean;
  errorMessage?: string;
}

export interface CompanyValuesCommonState {
  currentWorkingCompanyId: EntityId | null;
}

export interface CompanyValuesState {
  features: CompanyValuesMainState;
  search: CompanyValueSearchState;
  entities: EntitiesMap;
  common: CompanyValuesCommonState;
}

const featuresReducer = reducerWithInitialState<CompanyValuesMainState>({
  list: [],
  isLoading: false,
  isLoaded: false,
})
  .case(bootstrapValuesIndex, (state, { result }) => {
    return { ...state, list: result.company_value_features };
  })
  .case(loadCompanyValueFeatures.started, state => {
    return { ...state, isLoading: true };
  })
  .case(loadCompanyValueFeatures.done, (state, { result }) => {
    return { ...state, isLoading: false, isLoaded: true, list: result.result };
  })
  .case(loadCompanyValueFeatures.failed, (state, err) => {
    return { ...state, isLoading: false, isLoaded: false, errorMessage: err.error.message };
  });

const commonReducer = reducerWithInitialState<CompanyValuesCommonState>({
  currentWorkingCompanyId: null,
}).case(bootstrapValuesIndex, (state, { result }) => {
  return {
    ...state,
    currentWorkingCompanyId: result.current_company,
  };
});

const entitiesReducer = reducerWithInitialState<EntitiesMap>({
  companies: {},
  company_values: {},
  company_value_features: {},
  projects: {},
  images: {},
})
  .case(bootstrapValuesIndex, (state, { entities }) => {
    return mergeEntities(state, entities);
  })
  .cases([loadCompanyValueFeatures.done, loadCompaniesByCompanyValues.done], (state, { result }) => {
    return mergeEntities(state, result.entities);
  });

export default combineReducers({
  features: featuresReducer,
  search: searchReducer,
  entities: entitiesReducer,
  common: commonReducer,
});



// WEBPACK FOOTER //
// ./frontend/src/company_values/reducers/index.ts